import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import brcRatings from "../../../../src/data/articles/cube-prospective-the-brothers-war-commander/brc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  brcRatings,
  ProspectiveIntro,
  React
};